<template>
  <div v-if="questionsCompleted.length && questions.length">
    <div class="mb-4" v-if="isQuizzValid">
      <div>
        <p class="is-valid result-message">Vous avez validé cette vidéo et vous pouvez passer à la suivante !</p>
        <p class="text-muted">Vous avez eu {{ totalValidAnswers }} bonnes réponses sur {{ questions.length }}</p>
      </div>
      <button @click="goNext()" class="btn btn-primary btn-sm">Vidéo suivante</button>
    </div>
    <div class="mb-4" v-else>
      <div class="is-error result-message">Vous avez raté cette vidéo et vous devez recommencer</div>
      <p class="text-muted">Vous avez eu {{ totalValidAnswers }} bonnes réponses sur {{ questions.length }}</p>
      <button @click="goBack()" class="btn btn-primary btn-sm">Je recommence</button>
    </div>

    <div class="alert alert-info mb-4" role="alert">
      <ul class="mb-0">
        <li>Les propositions valides sont en vert.</li>
        <li>Si plusieurs propositions sont en vert, cela signifie que la question nécessite plusieurs réponses (la question est invalide même si vous en avez une réponse valide).</li>
        <li>Si vous avez une ou plusieurs réponses rouges, la question sera invalide.</li>
        <li>Si les propositions ont un numéro avant la proposition, c'est que les réponses doivent être dans le même ordre pour être valide.</li>
      </ul>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-3 mb-4" v-for="question in questions" :key="question.id">
        <div class="card h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">
              <span v-if="isValid(question)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon is-valid" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
              </span>

              <span v-else>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon is-error" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
              </span>
              <span class="h5">{{ question.name }}</span>
            </h4>
          </div>
          <div class="card-body">
            <div class="quizz-result">
              <div class="row">
                <div class="col-12">
                  <div class="question-title ">Propositions</div>
                  <ul v-if="question.proposal_type === 'ordered'" class="proposals">
                    <li v-for="proposal in getOrderedProposals(question)" :key="`ordered-${proposal.value}`">
                      {{ proposal.order }}. {{ proposal.name }}
                    </li>
                  </ul>
                  <ul v-else class="proposals">
                    <li :class="proposal.is_valid ? 'is-valid' : 'is-error'" v-for="proposal in question.proposals" :key="proposal.value">
                      {{ proposal.name }}
                    </li>
                  </ul>
                </div>
                <hr />
                <div class="col-12">
                  <div class="question-title">Vos réponses</div>
                  <ul v-if="question.proposal_type === 'ordered'" class="proposals">
                    <li :class="proposal.is_valid ? 'is-valid' : 'is-error'" v-for="proposal in getAnswer(question)" :key="proposal.value">
                    {{ proposal.order }}. {{ proposal.name }}
                    </li>
                  </ul>
                  <ul v-else class="proposals">
                    <li :class="proposal.is_valid ? 'is-valid' : 'is-error'" v-for="proposal in getAnswer(question)" :key="proposal.value">{{ proposal.name }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      questionsCompleted: []
    }
  },

  props: {
    questions: {
      type: Array,
      required: true
    },
    videoId: {
      type: Number,
      required: true
    }
  },

  computed: {
    totalValidAnswers () {
      const valid = this.questionsCompleted.filter((q) => q.is_valid)

      return valid.length
    },
    isQuizzValid () {
      if (this.questions.length >= 10) {
        if (this.totalValidAnswers >= 7) {
          return true
        }
      }

      if (this.questions.length / 3 > 0) {
        if (this.totalValidAnswers >= this.questions.length / 2) {
          return true
        }
      }

      return false
    }
  },

  methods: {
    getOrderedProposals (question) {
      if (question) {
        if (question.proposals.length) {
          return question.proposals
        }
      }
    },
    getAnswer (question) {
      const result = this.questionsCompleted.find((q) => q.question_id === question.id)

       if (result) {
         const decodeAnswers = JSON.parse(result.answers)

         if (question.proposal_type === 'ordered') {
          const answers = decodeAnswers.sort((d) => d.order).map((a) => question.proposals.find((p) => p.value === a.proposal))

          return answers
         } else {
          const answers = decodeAnswers.map((a) => question.proposals.find((p) => p.value === a))

          return answers
         }
       }
    },
    isValid (question) {
      const result = this.questionsCompleted.find((q) => q.question_id === question.id)

      if (result) {
        return result.is_valid
      }
    },
    goNext() {
      this.$emit('next')
    },
    goBack() {
      this.$emit('back')
    }
  },

  mounted() {
    axios.get(`/webapi/videos/${this.videoId}/completed`)
      .then((res) => {
        if (res && res.data) {
          this.questionsCompleted = res.data
        }
      })
      .catch(err => console.log(err))
  }
}
</script>

<style scoped>
.quizz-result {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.question-title {
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-bottom: 1rem;
}

.proposals {
  list-style-type: none;
  padding-inline-start: 0px;
}

.is-valid {
  color: #70AB37;
}

.is-error {
  color: #DB487E;
}

.icon {
  height: 1.25rem;
  width: 1.25rem;
}

.result-message {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
</style>
